






import { Component, Vue, Prop } from 'vue-property-decorator'

@Component

export default class ComponentLabel extends Vue {
  @Prop() text: string
  @Prop({ required: false }) cl: string
  @Prop({ required: false }) type: string
}
